import { LayoutState } from '~/src/stores/layout'
import LayoutServiceInterface from '~/src/utils/layout/LayoutServiceInterface'

export default class LayoutLocationsServiceStyleTwo implements LayoutServiceInterface {
  public getLayout(): Partial<LayoutState> {
    return {
      header: {
        display: true,
        displayMenuBurger: false,
        displayCart: false,
        displayCurrentFirm: true,
        displayDeliveryOptions: false,
        displayLanguagesSelector: false,
        displayUserActions: false,
        displayProductSearch: true,
        displayLocationSearch: false,
        logo: {
          disableLink: false
        },
        title: '',
        type: 'navigation'
      },
      subHeader: {
        display: false,
        variant: 'default'
      },
      content: {
        displayNotification: true
      },
      mainSideBar: {
        display: true,
        displayCart: true,
        displayDeliveryOptions: false,
        displayOrderSummary: false
      },
      footer: {
        display: false,
        displayGoToCartBtn: false,
        displayGoToCheckoutBtn: false,
        displayInformations: false,
        displayLinks: false
      },
      mobileNavigation: {
        display: true
      }
    }
  }
}
